/* tslint:disable */
/* eslint-disable */
/**
 * middleware
 * middleware API
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { HTTPValidationError } from '../models';
// @ts-ignore
import { TemplateRender } from '../models';
/**
 * TemplateApi - axios parameter creator
 * @export
 */
export const TemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Render Template
         * @param {TemplateRender} templateRender 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renderTemplate: async (templateRender: TemplateRender, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateRender' is not null or undefined
            assertParamExists('renderTemplate', 'templateRender', templateRender)
            const localVarPath = `/api/v1/template/-1`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2AuthorizationCodeBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2AuthorizationCodeBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(templateRender, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TemplateApi - functional programming interface
 * @export
 */
export const TemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Render Template
         * @param {TemplateRender} templateRender 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renderTemplate(templateRender: TemplateRender, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renderTemplate(templateRender, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TemplateApi - factory interface
 * @export
 */
export const TemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TemplateApiFp(configuration)
    return {
        /**
         * 
         * @summary Render Template
         * @param {TemplateRender} templateRender 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renderTemplate(templateRender: TemplateRender, options?: any): AxiosPromise<string> {
            return localVarFp.renderTemplate(templateRender, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for renderTemplate operation in TemplateApi.
 * @export
 * @interface TemplateApiRenderTemplateRequest
 */
export interface TemplateApiRenderTemplateRequest {
    /**
     * 
     * @type {TemplateRender}
     * @memberof TemplateApiRenderTemplate
     */
    readonly templateRender: TemplateRender
}

/**
 * TemplateApi - object-oriented interface
 * @export
 * @class TemplateApi
 * @extends {BaseAPI}
 */
export class TemplateApi extends BaseAPI {
    /**
     * 
     * @summary Render Template
     * @param {TemplateApiRenderTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    public renderTemplate(requestParameters: TemplateApiRenderTemplateRequest, options?: AxiosRequestConfig) {
        return TemplateApiFp(this.configuration).renderTemplate(requestParameters.templateRender, options).then((request) => request(this.axios, this.basePath));
    }
}
